import React, { useEffect, useState } from "react";
import useApi from "../utils/useApi";
import ic_no_data from "../img/ic_no_data.svg";
import CommonTreetructure from "../components/lead_and_quotation/CommonTreeStructureMenu";


const Roles = () => {
  const COMPANY_CODE = localStorage.getItem("companyCode") || "DOODDEMO";

  const {
    data: datagetAllMenuOfClient,
    loading: loadingdatagetAllMenuOfClient,
    error: errordatagetAllMenuOfClient,
    get: getAllMenuOfClient,
  } = useApi();
  const {
    data: datagetAllMenuOfThisRole,
    loading: loadinggetAllMenuOfThisRole,
    error: errorgetAllMenuOfThisRole,
    get: getAllMenuOfThisRole,
  } = useApi();
  const {
    data: dataSubModulesListInACompany,
    loading: loadingSubModulesListInACompany,
    error: errorSubModulesListInACompany,
    get: getSubmoduleListInACompany,
  } = useApi();
  const {
    data: dataModulesAlloted,
    loading: loadingModulesAlloted,
    error: errorModulesAlloted,
    get: getModulesAlloted,
  } = useApi();

  const {
    data: datapostTransferMenuToRole,
    error: errorpostTransferMenuToRole,
    loading: loadingpostTransferMenuToRole,
    post: postTransferMenuToRole,
  } = useApi();
  const {
    data: getData,
    loading: getLoading,
    error: getError,
    get: getRoles,
  } = useApi();
  const {
    data: postData,
    loading: postLoading,
    error: postError,
    post: postRoles,
  } = useApi();
  const {
    data: datagetAlreadyAllotedMenuOfARole,
    error: errorgetAlreadyAllotedMenuOfARole,
    loading: loadinggetAlreadyAllotedMenuOfARole,
    get: getAlreadyAllotedMenuOfARole,
  } = useApi();

  const [selectedRolesToRemove, setSelectedRolesToRemove] = useState(null);

  const [selecteSubmoduleList, setSelecteSubmoduleList] = useState(null);

  const [totalMenuArray, setTotalMenuArray] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [
    selectedCompanyObjectToCreateRole,
    setSelectedCompanyObjectToCreateRole,
  ] = useState(null);
  const [selectedMenusToGiveToRole, setSelectedMenusToGiveToRole] = useState(
    []
  );
  const [currentSelectedRoleForMenu, setCurrentSelectedRoleForMenu] =
    useState(null);

  const [selectedItemProduct, setSelectedItemProduct] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");

  const clickedOnMenu = (itemFromlick) => {
    console.log("itemFromlick ", itemFromlick);

    let fillyLength = selectedMenusToGiveToRole.filter(
      (itemFilly) => itemFilly.MENUNAME === itemFromlick.MENUNAME
    ).length;
    if (fillyLength > 0) {
      let fillyArray = selectedMenusToGiveToRole.filter(
        (itemFilly) => itemFilly.MENUNAME != itemFromlick.MENUNAME
      );
      setSelectedMenusToGiveToRole(fillyArray);
    } else {
      setSelectedMenusToGiveToRole((prev) => [...prev, itemFromlick]);
    }
  };

  useEffect(() => {
    console.log("datagetAllMenuOfThisRole", datagetAllMenuOfThisRole);
  }, [datagetAllMenuOfThisRole]);

  const clickedOnCheckMarkSubModule = (roleName) => {
    setCurrentSelectedRoleForMenu(roleName);

    console.log("roleName ", roleName);

    if (
      selectedRolesToRemove?.findIndex(
        (itemParent) => itemParent === roleName
      ) >= 0
    ) {
      setSelectedRolesToRemove(
        selectedRolesToRemove?.filter((item) => item != roleName)
      );
    } else {
      if (selectedRolesToRemove) {
        setSelectedRolesToRemove([...selectedRolesToRemove, roleName]);
      } else {
        setSelectedRolesToRemove([roleName]);
      }
    }
  };

  useEffect(() => {
   

    

    let encodedRole =  encodeURIComponent(currentSelectedRoleForMenu)

    let apiurl = `https://cubixweberp.com:213/api/ClientRoleMenuControl/${COMPANY_CODE}/${COMPANY_CODE}/${encodedRole}/MAINMENU/-`;

    console.log("apiurl current_role_of_logged_in_user->>", apiurl);

    getAllMenuOfThisRole(apiurl);
  }, [currentSelectedRoleForMenu]);

  useEffect(() => {
    let apiurl = `https://cubixweberp.com:213/api/ClientMenuControl/CUBOT/${COMPANY_CODE}/MAINMENU/-`;

    console.log("apiurl of client", apiurl);

    getAllMenuOfClient(apiurl);
  }, []);

  const callMenuOfRoleAgain = () => {
    let apiurl = `https://cubixweberp.com:213/api/ClientRoleMenuControl/${COMPANY_CODE}/${COMPANY_CODE}/${currentSelectedRoleForMenu}/MAINMENU/-`;

    console.log("apiurl current_role_of_logged_in_user", apiurl);

    getAllMenuOfThisRole(apiurl);
  };

  const addMenuToRoles = () => {
    const menuItems = selectedMenusToGiveToRole.map((menu) => ({
      CMPCODE: selectedCompanyObjectToCreateRole.COMPID,
      COMPID: selectedCompanyObjectToCreateRole.COMPID,
      ROLEID: currentSelectedRoleForMenu,
      PRODUCTID: selectedItemProduct.PRODUCTID,
      MODULEID: selectedItem?.MODULEID,
      SUBMODULEID: menu.SUBMODULEID,
      MENUID: menu.MENUID,
      MENUNAME: menu.MENUNAME,
      MODE: "ENTRY",
      IMAGEPATH: "/images/submodule/icon.png",
      ORDER: menu.ORDER,
    }));

    let serializedData = JSON.stringify(menuItems);

    console.log("menuItems array", serializedData);

    postTransferMenuToRole(
      "https://cubixweberp.com:213/api/crmmenumainclientrolereg",
      serializedData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };

  const getSubModulesInAModule = (selectedItemFromClick) => {
    getSubmoduleListInACompany(
      `https://cubixweberp.com:213/api/ClientMenuControl/CUBOT/${COMPANY_CODE}/SUBMODULES/${selectedItemFromClick.MODULEID}`
    );
  };

  useEffect(() => {
    if (postData) {
      console.log("post data", postData);
      if (postData.result?.trim()?.toUpperCase() === "SAVED") {
        alert("Success");
        setInputValue("");
        setLoading(false);
        getRoles(
          `https://cubixweberp.com:213/api/ClientMenuControl/${COMPANY_CODE}/${COMPANY_CODE}/ROLES/-`
        );
      }
    }
  }, [postData]);

  const handleSave = async () => {
    if (!inputValue.trim()) {
      setStatusMessage("Please enter some text.");
      return;
    }

    setLoading(true);
    setStatusMessage("");

    let arrayToPass = [
      {
        CMPCODE: COMPANY_CODE, // HERE ID OF ROLES OF CLIENTCOMPCODE
        COMPID: COMPANY_CODE, // HERE ID OF ROLES OF CLIENTCOMPCODE
        ROLE: inputValue,
        MODE: "ENTRY",
      },
    ];

    let serializedData = JSON.stringify(arrayToPass);

    postRoles(`https://cubixweberp.com:213/api/CRMRolesReg`, serializedData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const removeRoles = async () => {
    let arrayToPass = selectedRolesToRemove?.map((item) => {
      return {
        CMPCODE: COMPANY_CODE, // HERE ID OF ROLES OF CLIENTCOMPCODE
        COMPID: COMPANY_CODE, // HERE ID OF ROLES OF CLIENTCOMPCODE
        ROLE: item,
        MODE: "DELETE",
      };
    });

    let serializedData = JSON.stringify(arrayToPass);

    postRoles(`https://cubixweberp.com:213/api/CRMRolesReg`, serializedData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  useEffect(() => {
    //HERE CUBOT NO ROLE COMPANY AND COMPANY
    getRoles(
      `https://cubixweberp.com:213/api/ClientMenuControl/${COMPANY_CODE}/${COMPANY_CODE}/ROLES/-`
    );
  }, []);

  const getModulesInAProduct = () => {
    getModulesAlloted(
      `https://cubixweberp.com:213/api/ClientMenuControl/CUBOT/${COMPANY_CODE}/MODULES/SALESDOOD`
    );
  };

  useEffect(() => {
    getModulesInAProduct();
  }, []);

  return (
    <div className=" mx-auto p-6 bg-white rounded shadow-md">

{/* manoj sir told not to use special characters like + & etc because that will be problem in backend also in frontend also issue
because + , & etc breaks the url so 404 error  comes*/}

      <h2 className="text-lg font-bold mb-4">Enter Role Name</h2>

      <div className="flex items-center">
        <input
          type="text"
          placeholder="Type something..."
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          className=" border border-gray-300 rounded px-3 py-2 "
        />
        <button
          onClick={handleSave}
          disabled={loading}
          className="ms-3 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 disabled:opacity-50"
        >
          {loading ? "Saving..." : "Save"}
        </button>
      </div>
      {statusMessage && (
        <div className="mt-4 text-sm text-gray-700">{statusMessage}</div>
      )}

      <h2 className="text-lg font-bold mb-4 mt-6">Current List Of Roles</h2>
      <div className="mt-3">
        {getData?.length === 0 && getLoading === false && (
          <p className="flex justify-center items-center flex-col">
            {" "}
            <img style={{ width: "120px" }} src={ic_no_data} />
            <span> No data to show </span>
          </p>
        )}
        {getData?.map((item) => {
          return (
            <div
              className="flex items-center"
              onClick={() => clickedOnCheckMarkSubModule(item.ROLE)}
            >
              {selectedRolesToRemove?.findIndex(
                (itemParent) => itemParent === item.ROLE
              ) >= 0 ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6 text-green-600"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <rect
                    x="3"
                    y="3"
                    width="18"
                    height="18"
                    rx="2"
                    ry="2"
                    fill="currentColor"
                  />
                  <path
                    d="M9 12l2 2l4-4"
                    fill="none"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6 text-gray-400"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                </svg>
              )}

              <span className="ms-2">{item.ROLE}</span>
            </div>
          );
        })}
      </div>

      {selectedRolesToRemove?.length > 0 && (
        <button
          onClick={() => removeRoles()}
          className="mt-4 bg-red-600 text-white px-4 py-2 rounded hover:bg-red-900 disabled:opacity-50"
        >
          Remove
        </button>
      )}

      {datagetAllMenuOfClient && (
        <CommonTreetructure
          rawDataFromAPI={datagetAllMenuOfClient}
          selectedProjectObject={{ PRODUCTID: "SALESDOOD" }}
          typeOfTree={`Menus of ${COMPANY_CODE}`}
          transferType={"transfer_menu_role"}
          clientCompanyId={COMPANY_CODE}
          roleId={currentSelectedRoleForMenu}
          callMenuOfRoleAgain={callMenuOfRoleAgain}
          datagetAllMenuOfThisRole={datagetAllMenuOfThisRole}
        />
      )}

      {datagetAllMenuOfThisRole && (
        <CommonTreetructure
          rawDataFromAPI={datagetAllMenuOfThisRole}
          selectedProjectObject={{ PRODUCTID: "SALESDOOD" }}
          typeOfTree={"Role And Menus"}
          roleId={currentSelectedRoleForMenu}
          clientCompanyId={COMPANY_CODE}
          callMenuOfRoleAgain={callMenuOfRoleAgain}
          deleteType={"delete_menu_from_role"}
        />
      )}
    </div>
  );
};

export default Roles;
